import React from 'react';
import Card from 'components/card/card';
import { Columns, ColumnsItem } from 'components/columns';
import CtaBox from 'components/cta-box/cta-box';
import CtaBoxTitle from 'components/cta-box/cta-box-title';
import CtaBoxSubTitle from 'components/cta-box/cta-box-subtitle';
import { Header3, P2 } from 'components/typography';
import ButtonGroup from 'components/button-group/button-group';
import Button from 'components/button/button';
import { TextSize } from 'components/typography/text';
import A11yVisuallyHidden from 'components/a11y/a11y-visually-hidden';

type HelpLineItemAction = {
    actionText?: string;
    url?: string;
};

export type HelpLineItem = {
    itemTitle?: string;
    text?: string;
    actions?: HelpLineItemAction[];
};

type HelplineCardProps = {
    children?: React.ReactChild | React.ReactChild[];
    title?: string;
    icon?: any;
    items?: HelpLineItem[] | null;
};

const HelplineCard: React.FC<HelplineCardProps> = ({ title, icon, items }) => {
    return (
        <Card type={Card.Type.STROKE} hasHover={false} tag={'div'} fixedSize={true}>
            <CtaBox full={true}>
                <CtaBoxTitle>
                    <Columns equal={true} vAlignTop={true}>
                        <ColumnsItem size={ColumnsItem.size.fluid}>
                            <Header3 size={TextSize.LG} tag="h3">
                                {title}
                            </Header3>
                        </ColumnsItem>
                        {icon ? (
                            <ColumnsItem size={ColumnsItem.size['1/2']} end={true}>
                                {icon}
                            </ColumnsItem>
                        ) : null}
                    </Columns>
                </CtaBoxTitle>
                <ul className="helplines" role="list">
                    {items &&
                        items.map(({ itemTitle, text, actions }, index) => (
                            <li className="helplines__item" key={index}>
                                <CtaBoxTitle>
                                    <P2 tag="h4">
                                        <b>{itemTitle}</b>
                                    </P2>
                                </CtaBoxTitle>
                                <CtaBoxSubTitle>
                                    <P2>{text}</P2>
                                </CtaBoxSubTitle>
                                <CtaBoxTitle>
                                    <ButtonGroup hasWrap={true}>
                                        {actions &&
                                            actions.map(
                                                ({ actionText, url }, actionIndex) =>
                                                    actionText &&
                                                    url && (
                                                        <React.Fragment key={actionIndex}>
                                                            <Button
                                                                color={Button.color.Primary}
                                                                text={
                                                                    <span>
                                                                        {actionText}

                                                                        <A11yVisuallyHidden>
                                                                            , {itemTitle}
                                                                        </A11yVisuallyHidden>
                                                                    </span>
                                                                }
                                                                href={url}
                                                                target={
                                                                    url.startsWith('tel')
                                                                        ? undefined
                                                                        : '_blank'
                                                                }
                                                                size={Button.size.SMALL}
                                                                designType={
                                                                    Button.designType.STROKE
                                                                }
                                                                theme={Button.Theme.TWO}
                                                            />
                                                        </React.Fragment>
                                                    )
                                            )}
                                    </ButtonGroup>
                                </CtaBoxTitle>
                            </li>
                        ))}
                </ul>
            </CtaBox>
        </Card>
    );
};

export default HelplineCard;
